import { useMutation, useQueryClient } from '@tanstack/react-query';
import { estimateHeadersService } from '../services/estimateHeaders.service';

export function useUpdateEstimateStatus(estimateId?: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (statusCode: string) => estimateHeadersService.updateStatus(estimateId!, statusCode),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimates'] });
      queryClient.invalidateQueries({ queryKey: ['estimates', 'detail', estimateId] });
    },
  });

  return {
    updateStatus: mutation.mutateAsync,
    isUpdatingStatus: mutation.isPending,
    error: mutation.error as Error | null,
  };
}
